<template>
    <div class="mb-5">
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <Card class="card">
                <template #title>
                    Your Company
                </template>

                <template #content>
                    <div class="mb-5">
                        Update your company information
                    </div>
                    <!-- Name -->
                    <div class="field">
                        <label for="name">Company Name</label>
                        <InputText
                            id="name"
                            class="w-full"
                            type="text"
                            v-model="form.company_name"
                        />
                        <!-- <small v-if="form.errors.name" class="p-invalid">
                            {{ form.errors.name }}
                        </small> -->
                    </div>
                    <div class="field">
                        <label for="email">Address e-mail</label>
                        <InputText
                            id="email"
                            class="w-full"
                            type="email"
                            v-model="form.company_email"
                        />
                        <!-- <small v-if="form.errors.email" class="p-invalid">
                            {{ form.errors.email }}
                        </small> -->
                    </div>
                    <div class="field">
                        <label for="address">Address</label>
                        <Textarea id="address" name="address" class="w-full" v-model="form.company_address"></Textarea>
                    </div>
                    <div class="field">
                        <label for="NPWP">NPWP</label>
                        <InputText id="npwp" class="w-full" v-model="form.company_npwp"></InputText>
                    </div>
                    <div class="field">
                        <label for="phone_number">Phone Number</label>
                        <InputText id="phone_number" class="w-full" v-model="form.company_phone"></InputText>
                    </div>
                </template>

                <template #footer>
                    <Button
                        :loading="loading"
                        label="Save"
                        @click="save"
                    />
                </template>
            </Card>
            <Card class="card">
                <template #title>
                    Maps Location
                </template>
                <template #content>
                    <div class="mb-5">
                        Update your company maps location
                    </div>
                    <!-- Name -->
                    <div class="field">
                        <label for="latitude">Latitude</label>
                        <InputText
                            id="latitude"
                            class="w-full"
                            type="text"
                            v-model="form.company_maps_latitude"
                        />
                        <!-- <small v-if="form.errors.name" class="p-invalid">
                            {{ form.errors.name }}
                        </small> -->
                    </div>
                    <div class="field">
                        <label for="longitude">Longitude</label>
                        <InputText
                            id="longitude"
                            class="w-full"
                            v-model="form.company_maps_longitude"
                        />
                        <!-- <small v-if="form.errors.email" class="p-invalid">
                            {{ form.errors.email }}
                        </small> -->
                    </div>
                </template>

                <template #footer>
                    <Button
                        label="Save"
                        :loading="loading"
                        @click="save"
                    />
                </template>
            </Card>
            <Card class="card">
                <template #title>
                    Bank Account Information
                </template>
                <template #content>
                    <div class="mb-5">
                        Update your company maps location
                    </div>
                    <!-- Name -->
                    <div class="field">
                        <label for="bank">Bank Name</label>
                        <InputText
                            id="bank"
                            class="w-full"
                            placeholder="Bank Negara"
                            v-model="form.company_bank"
                        />
                        <!-- <small v-if="form.errors.name" class="p-invalid">
                            {{ form.errors.name }}
                        </small> -->
                    </div>
                    <div class="field">
                        <label for="account_name">Account Name</label>
                        <InputText
                            id="account_name"
                            class="w-full"
                            placeholder="PT. Angkasa Pura Maju"
                            v-model="form.company_account_bank_name"
                        />
                        <!-- <small v-if="form.errors.email" class="p-invalid">
                            {{ form.errors.email }}
                        </small> -->
                    </div>
                    <div class="field">
                        <label for="account_number">Account Number</label>
                        <InputText
                            id="account_number"
                            class="w-full"
                            placeholder="7391132684"
                            v-model="form.company_account_bank_number"
                        />
                        <!-- <small v-if="form.errors.email" class="p-invalid">
                            {{ form.errors.email }}
                        </small> -->
                    </div>
                </template>

                <template #footer>
                    <Button
                        label="Save"
                        :loading="loading"
                        @click="save"
                    />
                </template>
            </Card>
            <Card class="card">
                <template #title>
                    Company Logo
                </template>
                <template #content>
                    <img
                        :src="form.company_logo"
                        width="250"
                    />
                </template>
                <template #footer>
                    <FileUpload mode="basic" name="demo[]" :maxFileSize="300000" @select="onUpload"/>
                </template>
            </Card>
        </div>
    </div>
</template>
<script>
import AppLayout from '@/Layouts/AppLayout';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import FileUpload from 'primevue/fileupload';
import Image from 'primevue/image';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import axios from 'axios';

export default {
    layout: AppLayout,
    components: {InputText, Button, Card, Textarea, Image, FileUpload},
    data(){
        return{
            form: {},
            loading: false,
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/settings`)
            .then((data)=> {
                this.form = data.data;
            })
        },
        onUpload(event) {
            // this.form.Image = event.files[0].objectURL;
            let img = event.files[0];
            let formData = new FormData();

            formData.append('image',img);

            axios.post(`${this.$page.props.appUrl}api/image/change-logo`, formData)
            .then((data) => {
                this.loadData();
                this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
            })
            .catch((error) => {
                this.$toast.add({severity: 'error', summary: "Error", detail: error, life: 3000});
            });
        },
        save(){
            this.loading = true;
            axios.put(`${this.$page.props.appUrl}api/settings/${this.form.id}`, this.form)
            .then((data) => {
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Setting Updated ",
                    life: 3000,
                });
                this.loading = false;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Setting Not Updated " + error,
                    life: 3000,
                });
                this.loading = false;
            })
        }
    },
}
</script>
